"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var ParBrandsBrandingsCountriesListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsBrandingsCountriesListCtl, _super);
    function ParBrandsBrandingsCountriesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_country_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_id; });
        _this.dk_app_country_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_title; });
        _this.dk_app_country_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_country_code; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsBrandingsCountriesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    ParBrandsBrandingsCountriesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand branding country with id [" + id + "] not found !";
    };
    ParBrandsBrandingsCountriesListCtl.prototype.LoadData = function (Key, onDone) {
        var _this = this;
        webAApi_1.ListBrandBrandingCountryByBrandingIdGet.exec({ brand_aff_banner_id: Key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_country_id: resp.list[i].app_country_id,
                    app_country_title: resp.list[i].app_country_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_country_code: resp.list[i].app_country_code
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBrandingsCountriesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandBrandingCountry.exec({
            data: {
                brand_aff_branding_id: data.brand_aff_branding_id,
                app_country_id: data.app_country_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_country_id: data.app_country_id,
                app_country_title: resp.app_country_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                app_country_code: resp.app_country_code
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsBrandingsCountriesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandBrandingCountry.exec({
                data: {
                    brands_aff_branding_country_id: data.key,
                    app_country_id: data.app_country_id
                }
            }, function (resp) {
                _tmp.app_country_id = data.app_country_id;
                _tmp.app_country_title = resp.app_country_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.app_country_code = resp.app_country_code;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsBrandingsCountriesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsBrandingsCountriesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandBrandingCountry.exec({ data: { brands_aff_brandings_country_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParBrandsBrandingsCountriesListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsBrandingsCountriesListCtl = ParBrandsBrandingsCountriesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_brandings_list/ctl/ParBrandsBrandingsCountriesListCtl.ts
// module id = 954
// module chunks = 0